// src/components/ThemeToggleButton.js
// Single shared Gold/Dark toggle — every placement (Today, Journey, Tracklist, Moments,
// Favorites, Profile, Splash) wires into the SAME augustTheme state and
// setAndPersistAugustTheme setter App.js already owns (Profile's own toggle used this before
// any of these existed). No second parallel theme implementation.
import React from 'react'
import { Sun, Moon } from 'lucide-react'
import './ThemeToggleButton.css'

export default function ThemeToggleButton({ augustTheme, onAugustThemeChange, className = '' }) {
  const isDark = augustTheme === 'dark'
  return (
    <button
      type="button"
      className={`aug-theme-toggle${className ? ' ' + className : ''}`}
      aria-label={isDark ? 'Switch to gold theme' : 'Switch to dark theme'}
      onClick={() => onAugustThemeChange(isDark ? 'gold' : 'dark')}
    >
      {isDark ? <Sun size={18} strokeWidth={1.75} /> : <Moon size={18} strokeWidth={1.75} />}
    </button>
  )
}
